var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"max-width":"100%"},attrs:{"id":"app"}},[_c('div',{staticClass:"col-md-3",staticStyle:{"padding-right":"0"}},[_c('app-sidebar',{staticClass:"web-only"}),_vm._v(" "),_c('app-mobile-sidebar',{staticClass:"mobile-only",staticStyle:{"margin-right":"-30px"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-9",staticStyle:{"padding-right":"0","margin-top":"15px","margin-bottom":"15px"}},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e4bdd4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 592
// module chunks = 0